import moment from 'moment';

const SCHEDULE_MONTH = 'SCHEDULE_MONTH';

const initialState = {
  scheduleMonth: Number(moment().format('MM')),
};

function reducer(state = initialState, action = {}) {
  switch(action.type) {
    default:
      return state;

    case SCHEDULE_MONTH:
      return {
        ...state,
        scheduleMonth: action.month,
      };
  }
}

export default reducer;

export const setScheduleMonth = month => {
  return dispatch => {
    dispatch({
      type: SCHEDULE_MONTH,
      month,
    });
  };
};
